import { types } from '../actions/types';

const initialState = {
    data: {},
};

const setBorderRadiusReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case types.SET_BORDER_RADIUS:
            return {
                ...state,
                data: payload,
            };
        default:
            return state;
    }
};

export default setBorderRadiusReducer